import React from 'react';

export default function SupportModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,10,30,.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 20,
      }}
    >
      <div className="card card-pad-lg" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <h2>Need a hand?</h2>
        <p className="muted small">
          PMP Revise is a study aid, not a substitute for the official PMI materials. For
          account issues, contact your administrator. For exam policy and eligibility, always
          check pmi.org.
        </p>
        <div className="divider" />
        <button className="btn btn-primary btn-block" onClick={onClose}>Got it</button>
      </div>
    </div>
  );
}
